<template>
  <div class="page_main">
    <Spin fix size="large" v-if="table_loading"></Spin>

    <div class="page_tabs">
      <div class="search_div">
        <Input
          v-model="search_value"
          clearable
          search
          @on-enter="search_click"
          size="small"
          placeholder="搜索姓名"
          style="width: 100px"
        />
      </div>

      <div class="tabs_div">
        <Tabs v-if="tabs_show" size="small" :v-model="tabs_index" @on-click="click_tabs">
          <TabPane
            v-for="(item, i) in flow_class_list"
            :key="i"
            :name="item.value"
            :label="item.label"
          >
          </TabPane>
        </Tabs>
      </div>

      <div class="button_operation">
        <div v-if="is_action" class="button_1">
          <Button
            @click="click_action(item)"
            v-for="(item, i) in action_list"
            :loading="button_loading"
            :key="i"
            size="small"
            style="font-size: 12px; margin-right: 10px"
            type="primary"
            >{{ item.label }}
          </Button>
        </div>

        <Button
          v-if="is_action"
          @click="batch_update_info"
          size="small"
          style="font-size: 12px; margin-right: 10px"
          type="success"
          >批量更新信息
        </Button>

        <Button
          @click="click_get_back"
          v-if="tabs_index == 'FLOW_9A569' || tabs_index == 'FLOW_9B263'"
          size="small"
          style="font-size: 12px; margin-left: 10px"
          type="warning"
        >
          <Icon type="ios-arrow-dropleft" /> 返回上一步
        </Button>
      </div>
    </div>

    <div class="table_div">
      <Table
        size="small"
        :height="windowHeight - 185"
        :columns="columns"
        :data="table_data"
        @on-selection-change="tabs_selection_change"
      >
        <template #name="{ row }">
          <span class="name" @click="click_name(row)">{{ row.name }}</span>
        </template>
        <template #belong_name="{ row }"
          ><span class="belong_name" :title="row.belong_phone">{{
            row.belong_name
          }}</span>
        </template>
        <template #idcard="{ row }">
          <span class="idcard2" @click="click_idcard_num(row)">{{ row.idcard }}</span>

          <i
            title="已实名"
            v-if="row.is_certification == 1"
            class="iconfont iconrenzheng"
          ></i>

          <i
            title="未实名"
            v-else
            class="iconfont iconweirenzheng"
            @click="click_update_certification(row)"
          ></i>
        </template>
        <template #job_name="{ row }">
          <span class="idcard_num" @click="click_job_name(row)"
            >{{ row.job_name }}

            <Icon type="ios-create-outline" size="14" color="#0466dd" />
          </span>
        </template>
        <template #remarks="{ row }">
          <span class="idcard_num" @click="click_update_remarks(row)"
            >{{ row.remarks }}

            <Icon type="ios-create-outline" size="14" color="#0466dd" />
          </span>
        </template>
        <template #phone="{ row }">
          <div  @click="click_update_phone(row)">
            <span class="phone_span">{{ row.phone }}</span>
            <Icon
              class="phone_icon"
              type="ios-create-outline"
            />
          </div>
        </template>
      </Table>
      <div class="content_page">
        <Page
          show-elevator
          show-total
          :total="total_count"
          v-model="page"
          :page-size="limit"
          @on-change="page_change"
        />
      </div>
    </div>

    <!-- 更新手机号 -->
    <Modal v-model="update_phone_show" title="更新手机号" :footer-hide="true" width="300">
      <div>
        <Input
          maxlength="11"
          v-model="update_phone_value"
          placeholder="输入11位手机号码"
          style="width: 200px"
        />
      </div>
      <div class="update_phone_button">
        <Button type="primary" @click="update_phone">确认更新</Button>
      </div>
    </Modal>

    <update_idcard @change="update_idcard_change" ref="update_idcard"></update_idcard>

    <update_job_name
      @change="update_job_name_change"
      ref="update_job_name"
    ></update_job_name>

    <update_remarks @change="update_remarks_change" ref="update_remarks"></update_remarks>

    <resume_detail ref="resume_detail"></resume_detail>

    <batch_update_info ref="batch_update_info"></batch_update_info>
    <interview_update_phone ref="interview_update_phone" @change="interview_update_phone_change"></interview_update_phone>


  </div>
</template>

<script>
import { http } from "@/utils/http.js";
import watermark from "@/utils/shuiyin.js";
import update_idcard from "@/views/roster_manage/component/update_idcard2.vue";
import update_job_name from "../roster/update_job_name.vue";
import batch_update_info from "../component/batch_update_info.vue";
import update_remarks from "../roster/update_remarks.vue";
import interview_update_phone from '@/views/roster_manage/component/update_phone.vue'

import resume_detail from "@/views/roster_manage/component/resume_detail.vue";
export default {
  props: ["project_id"],
  name: "dairuzhi",
  components: {
    update_idcard,
    update_job_name,
    batch_update_info,
    update_remarks,
    resume_detail,
    interview_update_phone
  },

  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      table_loading: false,
      columns: [],
      table_data: [],

      page: 1,
      limit: 20,
      total_count: 0,
      tabs_index: "",
      tabs_show: true,
      flow_class_list: [],

      //选项
      action_list: [],
      is_action: false,
      //归属人
      belong_type_list: [],
      //系统用户列表
      sys_user_list: [],
      // 表格选择数据
      table_selection: [],

      search_type: "name",
      search_value: "",

      project_id: "",
      project_name: "",
      tabs_append: "",

      // 更新手机号
      update_phone_show: false,
      update_phone_value: "",
      update_phone_item: {},

      button_loading:false
    };
  },

  mounted() {
    this.window_change();
  },

  methods: {
    update_remarks_change() {
      this.get_dairuzhi_list();
    },

    click_update_remarks(row) {
      this.$refs.update_remarks.open(this.project_id, row);
    },

    
    click_update_phone(row) {
      this.$refs.interview_update_phone.open(row)
      
    },
    interview_update_phone_change(){
      this.get_dairuzhi_list()
    },

    //批量更新数据
    batch_update_info() {
      this.$refs.batch_update_info.open(this.project_id);
    },

    click_get_back() {
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content:
          "<p>返回上一步后当前状态会删除，员工会恢复到上一步【待操作】状态，操作后无法恢复，真的要继续吗？</p>",
        onOk: () => {
          that.get_back_affirm();
        },
        onCancel: () => {},
      });
    },

    //返回上一步
    get_back_affirm() {
      var interview_id_list = [];
      for (let i = 0; i < this.table_selection.length; i++) {
        var ivid = this.table_selection[i]["interview_id"];
        interview_id_list.push(ivid);
      }

      if (interview_id_list.length == 0) {
        this.$Message.error("请至少选择一位");
        return;
      }

      var that = this;
      var obj = {
        project_id: this.project_id,
        interview_id_list: interview_id_list,
        flow_id: this.tabs_index,
      };
      http("post", process.env.VUE_APP_HOST + "/my_project/get_back", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_dairuzhi_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    open() {
      var query = this.$route.query;
      if (query.flow_id) {
        this.tabs_index = query.flow_id;
      }
      if (query.project_id) {
        this.project_id = query.project_id;
      }
      if (query.project_name) {
        this.project_name = query.project_name;
      }
      if (query.tabs_append) {
        this.tabs_append = query.tabs_append;
      }

      this.get_flow_class_list();
      this.create_shuiyin();
    },

    update_job_name_change() {
      this.get_dairuzhi_list();
    },

    // 更新岗位
    click_job_name(row) {
      this.$refs.update_job_name.open(this.project_id, row);
    },

    //点击更新实名
    click_update_certification(item) {
      var resume_id = item.resume_id;
      var that = this;
      this.$Modal.confirm({
        title: "实名检测",
        content: "<p>确认要对姓名跟身份证进行实名校验吗?" + "</p>",
        onOk: () => {
          that.update_certification_request(resume_id);
        },
        onCancel: () => {},
      });
    },

    update_certification_request(resume_id) {
      var that = this;
      var obj = {
        resume_id: resume_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/certification",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_dairuzhi_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    //点击身份证号
    click_idcard_num(item) {
      this.$refs.update_idcard.open(item);
    },

    update_idcard_change() {
      this.get_dairuzhi_list();
    },

    //点击搜索
    search_click() {
      this.page = 1;
      this.get_dairuzhi_list();
    },
    create_shuiyin() {
      var user_info = window.localStorage.getItem("user_info");
      if (user_info) {
        var user_info_dict = JSON.parse(user_info);
        var name = user_info_dict.name;
        watermark.set("保密信息-" + name, "220px");
      }
    },
    //点击小勾
    tabs_selection_change(e) {
      this.table_selection = e;
    },

    click_action(item) {
      var that = this;
      this.$Modal.confirm({
        title: "操作警告",
        content:
          "<p>确认要更新状态为【" +
          item.label +
          "】吗，更新状态将无法修改，强烈建议检查无误后确认！</p>",
        onOk: () => {
          that.click_action_request(item);
        },
        onCancel: () => {},
      });
    },

    //点击操作按钮,下一个流程
    click_action_request(item) {
      var interview_id_list = [];
      for (let i = 0; i < this.table_selection.length; i++) {
        var interview_id = this.table_selection[i]["interview_id"];
        interview_id_list.push(interview_id);

        // 如果是面试通过，判断是否实名
        if (item.value == "FLOW_11A8A") {
          var row_item = this.table_selection[i];
          console.log(row_item);
          if (row_item.is_certification == 0) {
            this.$Message.error(row_item.name + "-身份证未实名,请先点红色图标进行实名");
            return;
          }
        }
      }
      if (interview_id_list.length == 0) {
        this.$Message.error("请至少选择一行");
        return;
      }
      if (item.value == "") {
        this.$Message.error("flow_id异常");
        return;
      }
      var that = this;
      var obj = {
        flow_id: item.value,
        current_flow_id: this.tabs_index,
        interview_id_list: interview_id_list,
      };
      this.button_loading=true
      this.table_loading = true;
      http("post", process.env.VUE_APP_HOST + "/my_project/dairuzhi/next_flow", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_flow_class_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
          that.button_loading=false
        })
        .catch((res) => {
          that.table_loading = false;
          console.log(res, "请求出错");
          that.button_loading=false
        });
    },

    click_new_mianshi_button() {
      this.add_resume_show = true;
      this.get_belong_type();
      this.get_dx_sys_user();
    },

    //系统用户列表
    get_dx_sys_user() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/daimianshi/dx_sys_user",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.sys_user_list = res.data.user_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //归属人类型
    get_belong_type() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/daimianshi/belong_type",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.belong_type_list = res.data.type_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_tabs(e) {
      this.tabs_index = e;
      this.get_dairuzhi_list();
      this.get_action_list();
    },

    //获取流程类
    get_flow_class_list() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/dairuzhi/flow_class_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.flow_class_list = res.data.flow_class_list;
            that.tabs_index = that.flow_class_list[0]["value"];

            that.get_dairuzhi_list();
            that.get_action_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    //获取按钮列表
    get_action_list() {
      var that = this;
      var obj = {
        flow_id: this.tabs_index,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/dairuzhi/action_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.is_action = res.data.is_action;
            that.action_list = res.data.action_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取待入职列表
    get_dairuzhi_list() {
      var that = this;
      var obj = {
        page: this.page,
        project_id: this.project_id,
        flow_id: this.tabs_index,
        search_type: this.search_type,
        search_value: this.search_value,
      };
      this.table_loading = true;
      http("post", process.env.VUE_APP_HOST + "/my_project/dairuzhi/list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.columns = res.data.columns;
            that.table_data = res.data.resume_list;
            that.limit = res.data.limit;
            that.total_count = res.data.total_count;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;
          console.log(res, "请求出错");
        });
    },
    page_change(e) {
      this.page = e;
      this.get_dairuzhi_list();
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },

    click_name(row) {
      this.$refs.resume_detail.open(row, this.project_id);
    },
  },
};
</script>

<style scoped>
.idcard2{
  color: #0466dd;
  cursor: pointer;
}
.phone_span{
  color: #0466dd;
  cursor: pointer;
}

.button_1 {
  display: flex;
  align-items: center;
}

.name {
  color: #0466dd;
  cursor: pointer;
}
.update_phone_button {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.phone_icon {
  font-size: 14px;
  cursor: pointer;
  margin-left: 3px;
}

.phone_icon:hover {
  color: #0073ff;
}

.update_job_butotn {
  display: flex;
  margin-top: 20px;
  justify-content: flex-end;
}

.update_job_div_span {
  font-size: 14px;
  color: #333;
  margin-right: 10px;
}

.update_job_div {
  display: flex;
  align-items: center;
}

.idcard_num {
  cursor: pointer;
}

.idcard_num:hover {
  color: #0466dd;
}

.search_div {
  margin-bottom: 5px;
}

.iconweirenzheng {
  font-size: 12px;
  color: #fb0000;
  margin-left: 3px;
  cursor: pointer;
}

.iconrenzheng {
  font-size: 10px;
  color: #01b729;
  margin-left: 3px;
  cursor: pointer;
}

.belong_name {
  color: #0466dd;
  cursor: pointer;
}

.table_div {
  position: relative;
}

.hengxian {
  border-top: 1px dashed #ececec;
  margin: 10px 0;
}

.field_item_box {
  display: flex;
  width: 800px;
  padding-left: 10px;
}

.content_page {
  padding: 8px 0 7px 0;
  text-align: center;
}

.page_tabs {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.page_main {
  padding: 0 10px 0px 10px;
  background-color: #fff;
  border-radius: 5px;
  position: relative;
}

.add_resume_button_opertion {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

.field_title {
  width: 100px;
  flex-shrink: 0;
}

.field_item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 20px;
}

.button_operation {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  width: 100px;
}
</style>
